import { AccentButton } from "./AccentButton";
import { BaseButton } from "./BaseButton";

import { BaseButtonProps } from "./BaseButton";
import { DangerButton } from "./DangerButton";
import { PrimaryButton } from "./PrimaryButton";
import { SecondaryButton } from "./SecondaryButton";

interface ButtonProps extends BaseButtonProps {
    theme: 'Primary' | 'Secondary' | 'Accent' | 'Danger'
}


export function Button({ theme, children, ...props }: ButtonProps): React.ReactElement {
   switch (theme) {
    case 'Primary':
        return <PrimaryButton {...props}>
            {children}
        </PrimaryButton>

    case 'Secondary':
        return <SecondaryButton {...props}>
            {children}
        </SecondaryButton>

    case 'Accent':
        return <AccentButton {...props}>
            {children}
        </AccentButton>

    case 'Danger':
        return <DangerButton {...props}>
            {children}
        </DangerButton>
   
    default:
        return <BaseButton>
            {children}
        </BaseButton>
   }
}
